defer('jQuery', () => {
  $(document).ready(function () {

      //collection carousel section--------
      var $currentlySelectedCollection = $(".collection-selector").first();
      selectCarousel($currentlySelectedCollection);

      $(".collection-selector").on("click", function(e){
          if($(this).find('.nosto-carousel')){
              $('.collection-carousel-wrapper.nosto-wrapper').css({'opacity' : 0});
              var nostoID = $(this).data('collection-title-handle');
              $("#"+nostoID).find(".nosto-carousel").find(".grid").slick("refresh");
          }
          $(".collection-selector").removeClass("active");
          $(".collection-carousel-wrapper").removeClass("active");
          $(".collection-plain").removeClass("active");
          selectCarousel($(e.target));
          $("#"+nostoID).find(".nosto-carousel").find(".grid").slick("refresh");
      });
      //----------------------------------
      
      //Reassurance Blocks carousel section--------
      $('.fp__slider').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          draggable: false,
          responsive: [
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrows: false,
                      dots: true,
                      draggable: true
                  }
              }
          ]
      });
      //----------------------------------
  });

  function selectCarousel($target){
      var collectionTitleHandle = $target.data( "collectionTitleHandle" );
      $target.addClass("active");
      $("div[data-collection-products-handle='" + collectionTitleHandle + "']").addClass("active");
      $(".collection-selector").css("background-color", "transparent");
      $(".collection-selector.active").css("background-color", $(".collection-selector.active").data("collection-color"));

          if( $("div[data-collection-products-handle='" + collectionTitleHandle + "']").children(".slick-initialized").length > 0 ){
              $('.collection-carousel-wrapper.active').find(".collection-carousel").slick("setPosition");
          } else {
              $('.collection-carousel-wrapper.active').find(".collection-carousel").slick({
                  lazyLoad: 'ondemand',
                  arrows: true,
                  infinite: false,
                  slidesToShow: 6,
                  slidesToScroll: 6,
                  adaptiveHeight: true,
                  prevArrow: '<span class="slick-prev lnr lnr-chevron-left"></span>',
                  nextArrow: '<span class="slick-next lnr lnr-chevron-right"></span>',
              });
          }

      jQuery('.collection-carousel-wrapper.nosto-wrapper').on('afterChange', function(event, slick, currentSlide){
          if(jQuery(".slick-slide").hasClass("slick-active")){
              $(this).css({'opacity' : 1});
              // $(this).find(".grid").slick("refresh");
          }else{

          }
      });
  }
});
